import React, { Fragment } from "react";

import img13 from "../../../images/service/Healthcare Blockchain Development/1.png";
import img14 from "../../../images/service/Healthcare Blockchain Development/2.png";
import img15 from "../../../images/service/Healthcare Blockchain Development/3.png";
// Service icons
import sIcon1 from "../../../images/icon/service-icon01.svg";
import sIcon2 from "../../../images/icon/service-icon02.svg";
import sIcon3 from "../../../images/icon/service-icon03.svg";
import sIcon4 from "../../../images/icon/service-icon04.svg";
import sIcon5 from "../../../images/icon/service-icon05.svg";
import sIcon6 from "../../../images/icon/service-icon06.svg";

// Common Components
import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import Footer from "../../../components/footer/Footer";

import HeroSection from "../../../components/PageSection/HeroSection";
import ServiceCardsSection from "../../../components/PageSection/ServiceCardSection";
import Benefit from "../../../components/PageSection/BenefitSection";
import KeyFeaturesSection from "../../../components/PageSection/KeyFeature";
import WhyChooseUsSection from "../../../components/PageSection/WhyChooseUsSection";
import FaqSection from "../../../components/PageSection/FAQsection";
import FinalCenteredCTA from "../../../components/PageSection/FinalCTA";
import Industries from "../../../components/Industries/Industries";
import TheorySection from "../../../components/PageSection/Theory";

// =====================
// DATA
// =====================

const serviceCards = [
  {
    icon: sIcon1,
    title: "Medical Data Management",
    content:
      "Securely store, share, and manage patient medical records using tamper-proof blockchain technology.",
  },
  {
    icon: sIcon2,
    title: "Healthcare Smart Contracts",
    content:
      "Automate insurance claims, billing, and patient consent through transparent smart contracts.",
  },
  {
    icon: sIcon3,
    title: "Supply Chain Tracking",
    content:
      "Track pharmaceutical products from manufacturer to patient to prevent counterfeit drugs.",
  },
];

const benefits = [
  {
    title: "Improved Data Security",
    description:
      "Blockchain ensures patient records remain encrypted, immutable, and protected from unauthorized access.",
    icon: sIcon1,
  },
  {
    title: "Enhanced Transparency",
    description:
      "All healthcare transactions are recorded on a shared ledger, improving accountability and trust.",
    icon: sIcon2,
  },
  {
    title: "Faster Claims Processing",
    description:
      "Smart contracts automate insurance verification and claim settlements.",
    icon: sIcon3,
  },
  {
    title: "Patient-Centric Control",
    description:
      "Patients gain full control over who can access their medical data.",
    icon: sIcon4,
  },
];

const faqs = [
  {
    q: "How does blockchain help healthcare systems?",
    a: "Blockchain enhances healthcare by securing patient data, improving interoperability, and automating administrative processes.",
  },
  {
    q: "Is blockchain safe for storing medical records?",
    a: "Yes. Blockchain uses cryptography and decentralization to protect sensitive healthcare information.",
  },
  {
    q: "Can blockchain prevent counterfeit medicines?",
    a: "Absolutely. Blockchain enables end-to-end tracking of pharmaceuticals across the supply chain.",
  },
  {
    q: "Does blockchain comply with healthcare regulations?",
    a: "Blockchain solutions can be designed to comply with healthcare standards such as HIPAA and data privacy laws.",
  },
];

// =====================
// PAGE COMPONENT
// =====================

export default function HealthcareBlockchainDevelopment() {
  return (
    <Fragment>
      <Header />

      <PageTitle
        pageTitle="Healthcare Blockchain Development"
        pagesub="Secure, transparent, and patient-centric healthcare solutions"
      />

      {/* HERO SECTION */}
      <HeroSection
        title={
          <>
            Transform Healthcare with{" "}
            <span className="gradient-text">Blockchain Technology</span>
          </>
        }
        subtitle={`Build secure, interoperable, and transparent healthcare systems.
Leverage blockchain to protect patient data, streamline operations, and enhance trust across the healthcare ecosystem.`}
        buttonText="Book Consultation"
        buttonLink="/contact"
        image={img13}
        imageAlt="Healthcare Blockchain Development"
      />

      {/* ================= THEORY 1 ================= */}
      <TheorySection
        title="Why Blockchain in Healthcare?"
        image={img14}
        paragraphs={[
          "Healthcare systems handle highly sensitive patient data, making security, privacy, and data integrity critical challenges. Traditional systems often struggle with data breaches and limited interoperability.",
          "Blockchain introduces a decentralized and tamper-proof infrastructure that ensures secure data sharing, transparent access control, and improved collaboration between healthcare providers.",
        ]}
      />

      {/* SERVICES */}
      <ServiceCardsSection
        title="Our Healthcare Blockchain Services"
        cards={serviceCards}
      />

      {/* ================= THEORY 2 ================= */}
      <TheorySection
        title="Challenges in Traditional Healthcare Systems"
        image={img15}
        paragraphs={[
          "Fragmented data systems, manual processes, and lack of transparency slow down healthcare operations and impact patient care.",
          "Blockchain addresses these challenges by enabling secure data exchange, automated workflows, and complete traceability across healthcare networks.",
        ]}
      />

      {/* BENEFITS */}
      <Benefit
        title="Benefits of Blockchain in Healthcare"
        benefits={benefits}
      />

      {/* KEY FEATURES */}
      <KeyFeaturesSection
        title="Key Features of Our Healthcare Blockchain Solutions"
        subtitle="Designed for security, compliance, and operational efficiency"
        features={[
          {
            icon: sIcon1,
            title: "Decentralized Medical Records",
            description:
              "Eliminate single points of failure and enhance data reliability.",
          },
          {
            icon: sIcon2,
            title: "Patient Consent Management",
            description:
              "Give patients control over data access with cryptographic permissions.",
          },
          {
            icon: sIcon3,
            title: "Smart Contract Automation",
            description:
              "Automate billing, claims, and compliance workflows.",
          },
          {
            icon: sIcon4,
            title: "Supply Chain Transparency",
            description:
              "Track medicines and equipment throughout the supply chain.",
          },
          {
            icon: sIcon5,
            title: "Regulatory Compliance",
            description:
              "Design systems aligned with healthcare data protection standards.",
          },
          {
            icon: sIcon6,
            title: "Interoperability",
            description:
              "Enable secure data exchange across multiple healthcare providers.",
          },
        ]}
      />

      <Industries />

      {/* WHY CHOOSE US */}
      <WhyChooseUsSection
        items={[
          "Healthcare-focused blockchain expertise",
          "Security and compliance-driven architecture",
          "End-to-end blockchain implementation support",
        ]}
      />

      {/* FAQ */}
      <FaqSection faqs={faqs} />

      {/* FINAL CTA */}
      <FinalCenteredCTA />

      <Footer />
      <Scrollbar />
    </Fragment>
  );
}
